import React, { FunctionComponent, useMemo } from "react";
import { pickTextColorBasedOnBgColor } from "../../../../../utils";
import {
  BenchmarkStatus,
  ColorCriteria,
  MeasurementType,
} from "../../../../../../store/onboarding/types";

type Props = {
  measureType?: MeasurementType;
  colorCriteria: ColorCriteria;
  totalStudents: number | null;
  getStudentsNumByColorCriteria:
    | ((colorCriteria: ColorCriteria) => number)
    | null;
  withoutStats?: boolean;
  studentDistribution: any;
};

const MAX_DISPLAYED_VALUE = 1999;

const ColorColorCriteriaRow: FunctionComponent<Props> = (props) => {
  const {
    measureType,
    colorCriteria,
    withoutStats,
    studentDistribution
  } = props;

  const displayRange = useMemo(() => {
    if(colorCriteria){
      if (measureType === MeasurementType.PERCENTAGE) {
        return `${colorCriteria.range_min}% - ${colorCriteria.range_max}%`;
      } else {
        // For checking the range max for beyond the range
        if (colorCriteria.range_max! > MAX_DISPLAYED_VALUE) {
          return `${colorCriteria.range_min}+`;
        }
        return `${colorCriteria.range_min} - ${colorCriteria.range_max}`;
      }
    }
  }, [measureType, colorCriteria]);

  return (colorCriteria &&
    <tr
      style={{
        backgroundColor: colorCriteria.color,
        color: pickTextColorBasedOnBgColor(colorCriteria.color),
      }}
    >
      <td width={120}>{colorCriteria.display_name}</td>
      {measureType !== MeasurementType.CATEGORY && <td>{displayRange}</td>}

      {!withoutStats && (
        <>
          <td>{studentDistribution[displayRange!]?.studentCount}</td>
          <td>{studentDistribution[displayRange!]?.percentage || 0} %</td>
        </>
      )}
    </tr>
  );
};

export default ColorColorCriteriaRow;
